import nouns from './nouns.json';


// ✅ CORRECCIÓN: Aplanar ambos archivos en una sola lista
export const GRAMMAR_M2 = [ 
  ...nouns
];